export const aciProductDisney = {
    iconName: 'product-disney',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M17.636 4.125c-1.81 0-3.408 1.365-3.728 3.15.32.105.746.21 1.065.315.107-1.365 1.278-2.415 2.663-2.415 1.491 0 2.77 1.26 2.77 2.835 0 1.365-1.066 2.625-2.344 2.835.107.315.213.735.32 1.05A3.958 3.958 0 0021.47 8.01c0-2.1-1.704-3.885-3.834-3.885z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M14.234 6.284c-.152.31-.263.642-.326.99.16.053.346.106.533.158.186.053.372.105.532.158a2.577 2.577 0 01.371-1.141 2.69 2.69 0 012.292-1.274c1.491 0 2.77 1.26 2.77 2.835 0 1.083-.672 2.1-1.588 2.58a2.53 2.53 0 01-.756.255c.053.157.107.341.16.525.053.184.106.367.16.525a4.078 4.078 0 001.118-.44 3.95 3.95 0 001.97-3.445c0-2.1-1.704-3.885-3.834-3.885-1.402 0-2.677.819-3.33 2.018-.024.046-.049.093-.072.141z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M6.804 10.836s.724.095.83.412c.096.223-.01.752-.01.752-.32.105-.959 0-1.065-.106.106-.423.245-1.058.245-1.058z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M7.12 10.905c-.17-.05-.316-.07-.316-.07s-.083.381-.17.75a24.827 24.827 0 01-.05.205l.064.013-.045.046a.854.854 0 01-.024-.038 15.44 15.44 0 01-.02.083.294.294 0 00.098.054 1.98 1.98 0 00.473.09c.18.013.363.005.494-.038 0 0 .106-.53.01-.752-.038-.113-.155-.198-.289-.26a1.344 1.344 0 00-.225-.083zm-.46 1.015v.004l-.005-.006.006.002z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M13.908 8.323c.107 0 .64.21.852 0 .213-.21.213-.42.213-.735-.213-.21-1.065-.315-1.065-.315v1.05z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M14.19 8.383c.197.041.442.067.57-.06.213-.21.213-.42.213-.735-.142-.14-.568-.233-.837-.28-.133-.023-.228-.035-.228-.035v1.05c.026 0 .075.012.139.028.042.01.09.022.143.032z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M18.17 10.844c-.214 0-.64 0-.746.315-.107.21-.107.525 0 .84.32.105 1.065 0 1.065 0s-.107-.945-.32-1.155z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M18.489 11.999s-.012-.102-.035-.247l-.002-.01a6.067 6.067 0 00-.01-.067l-.004-.02a5.629 5.629 0 00-.031-.164c-.053-.26-.133-.543-.238-.647-.098 0-.24 0-.376.03-.16.036-.312.114-.37.285a.936.936 0 00-.072.515c.011.105.036.215.073.325.161.053.431.052.659.039a6.032 6.032 0 00.189-.015c.129-.012.217-.024.217-.024z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M6.879 10.845C5.6 10.635 4.536 9.48 4.536 8.01c0-1.575 1.278-2.835 2.769-2.835 1.385 0 2.556 1.05 2.77 2.415.319-.21.638-.315.958-.315-.32-1.785-1.917-3.15-3.728-3.15-2.13 0-3.834 1.785-3.834 3.885a3.958 3.958 0 003.088 3.885c.107-.42.213-.735.32-1.05z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M10.615 6.108c-.658-1.18-1.921-1.983-3.31-1.983-2.13 0-3.834 1.785-3.834 3.885a3.95 3.95 0 001.964 3.44 4.038 4.038 0 001.124.445c.107-.42.213-.735.32-1.05a2.69 2.69 0 01-.817-.276 2.883 2.883 0 01-1.526-2.56c0-1.574 1.278-2.834 2.769-2.834.964 0 1.824.509 2.33 1.278a2.877 2.877 0 01.44 1.137c.145-.096.29-.17.436-.222a1.54 1.54 0 01.522-.093 3.755 3.755 0 00-.418-1.167z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M11.14 8.011v.315s.851-.21 1.384-.21c.533 0 1.385.21 1.385.21v-.315c0-.315 0-.525.106-.84 0 0-.959-.105-1.491-.105-.533 0-1.598.21-1.491.21.106.21.106.525.106.735z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M11.14 8.326v-.315c0-.21 0-.525-.107-.735-.01 0-.01-.002 0-.005a9.902 9.902 0 011.205-.19 3.472 3.472 0 01.558-.008c.533.023 1.219.098 1.219.098-.107.315-.107.525-.107.84v.315l-.019-.004a8.45 8.45 0 00-1.18-.199 2.684 2.684 0 00-.37 0 5.739 5.739 0 00-.54.068c-.357.06-.66.135-.66.135z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M18.488 11.895c-.213.104-.533.104-.746.104h-.32c.107.525.213 1.05.213 1.575 0 2.94-2.343 5.355-5.112 5.355-2.77 0-5.112-2.414-5.112-5.354 0-.525.106-1.05.213-1.575h-.32c-.32 0-.532 0-.745-.105-.107.524-.213 1.05-.213 1.575 0 3.57 2.769 6.404 6.177 6.404 3.408 0 6.178-2.834 6.178-6.404 0-.526-.107-1.05-.213-1.575z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M17.619 13.2a9.723 9.723 0 00-.197-1.2h.32c.073 0 .16 0 .25-.005.17-.008.356-.032.496-.1.08.4.162.802.196 1.203a4.438 4.438 0 01.016.476c-.054 3.52-2.802 6.3-6.177 6.3-3.375 0-6.123-2.78-6.176-6.3l-.001-.104c0-.124.006-.247.016-.37.034-.402.115-.804.197-1.205.155.076.31.097.507.102.073.002.152.002.238.002h.32l-.022.107a9.725 9.725 0 00-.175 1.094 4.591 4.591 0 00-.016.375c0 2.94 2.343 5.354 5.112 5.354 2.77 0 5.113-2.414 5.113-5.354a4.085 4.085 0 00-.017-.375z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M11.14 8.327c-.214.106-.658.194-.853 0-.13-.13-.213-.212-.213-.743.213-.212.746-.318.959-.318.213.212.213.742.106 1.06z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M10.64 7.323c-.214.051-.443.139-.566.261 0 .174.01.3.026.395l.167.056-.081.08a.804.804 0 01-.076-.087c.036.158.098.22.177.299.136.135.395.133.61.083a1.271 1.271 0 00.242-.083c.07-.207.094-.503.044-.743h-.15V7.39a.883.883 0 01.1.088.659.659 0 01.036.046.574.574 0 00-.136-.258c-.05 0-.118.005-.195.017a.809.809 0 01.12.058l-.207.207-.112-.225z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
